import { INTEGRATE_SUPPORTER_ACCOUNTS } from 'actions/supporters'
import { SIGN_IN } from 'actions/auth'
import { REFRESH_USER_DATA } from 'actions/users'
import { RECONNECT_TRACKED_ACCOUNT_PROVIDER } from 'actions/trackedAccountProviders'
import update from 'immutability-helper'

const setTrackedAccountProviders = (state, action) => (
  action.payload.data.entities.trackedAccountProviders
)

const updateTrackedAccountProvider = (state, { payload: { data: { result: trackedAccountProviderId, entities: { trackedAccountProviders} } } }) => (
  update(state, { [trackedAccountProviderId]: { $set: trackedAccountProviders[trackedAccountProviderId] } })
)

const handlers = {
  [`${INTEGRATE_SUPPORTER_ACCOUNTS}_FULFILLED`]: setTrackedAccountProviders,
  [`${SIGN_IN}_FULFILLED`]: setTrackedAccountProviders,
  [`${REFRESH_USER_DATA}_FULFILLED`]: setTrackedAccountProviders,
  [`${RECONNECT_TRACKED_ACCOUNT_PROVIDER}_FULFILLED`]: updateTrackedAccountProvider
}

export default function trackedAccountProvidersReducer(state = {}, action) {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}
